<template>
  <div class="main">
    <div class="title">
      <span class="t-l">学习任务</span>
      <div class="t-r">
        <router-link v-if="total<15" to="/books/StudyTaskHistory"><span class="use-his">使用记录</span></router-link>
        <div v-if="total>=15" @click="showTip" class="use-his">使用记录</div>
        <a-divider type="vertical" style="margin: 10px"/>
        <router-link v-if="total<15" to="/books/StudyTaskRecommend"><span class="pre">备课资源</span></router-link>
        <div v-if="total>=15" @click="showTip" class="pre">备课资源</div>
        <span class="add-pre" @click="add" v-if="total<10">
          <img class="add-img" src="@/assets/image/add.png" alt="">
          <span class="add-text">添加</span>
        </span>
      </div>
    </div>
    <ul v-if="taskList&&taskList.length>0" class="cont-ul">
      <li class="cont-li" v-for="(item, index) in taskList" :key="index">
        <div class="task-title">
          <div class="task-content" v-html="item.content||item.relatedReadContent"></div>
          <div class="task-type">
            <span class="type-detail" v-if="item.isPublish===0">
              <img src="../../../../assets/image/no-publish.png" alt="">
              {{ format.isPublish(item.isPublish) }}
            </span>
            <span class="type-detail" v-if="item.isPublish === 1">
              <img class="img-type-detail" v-if="item.taskType === 1" src="../../../../assets/image/task-clsss.png"
                   alt="">
              <img class="img-type-detail" v-if="item.taskType === 2" src="../../../../assets/image/task-group.png"
                   alt="">
              {{ format.taskType(item.taskType) }}
            </span>
          </div>
        </div>
        <ul class="activity-ul" v-if="item.activityList">
          <li class="" v-for="(act,i) in item.activityList" :key="i">
            <div class="activity-li">
              <span class="act-num">活动{{ format.number2Text(i) }}</span>
              <span class="act-type">【{{ format.taskStyle(act.activityStyle) }}】</span>
              <span class="act-cont" v-html="act.activityContent||act.activityStyleCustomName"></span>
            </div>
            <div class="act-li" v-show="act.activityStyle===6">
              <span class="act-read" v-for="(a) in act.relatedReadSimples" @click="ralatedRead(a)">{{
                  a.displayTitle
                }}</span>
            </div>
            <rich-text-view
                :key="new Date().getTime()"
                class="content"
                :content='act&&act.answerContent'
                :images="act.imageList||[]"
                :videos="act.videoList||[]"
                :audios="act.audioList||[]"
            ></rich-text-view>
            <!--            <a-col style="margin-bottom: 10px">-->
            <!--              <a-row class="imgList">-->
            <!--                <a-row>-->
            <!--                  <a-col class="newImg" :span="6" v-for="(item, index) in act.imageList" :key="index">-->
            <!--                    <img width="200px" height="100px" :src="resBasePath + '/' + item.path" alt=""/>-->
            <!--                  </a-col>-->
            <!--                </a-row>-->
            <!--                <a-row style="margin-top: 10px">-->
            <!--                  <a-col class="editVideo" :span="6" v-for="(item, index) in act.videoList" :key="index">-->
            <!--                    <video class="editvideoPlay" style="outline-style: none;background-color: black" controlslist="nodownload;"-->
            <!--                           :disablePictureInPicture="true" :src="resBaseVideo + '/' + item.path"-->
            <!--                           controls="controls"-->
            <!--                           :poster="item.coverPath && item.coverPath != null ? item.coverPath : '@/assets/imgs/video.png'"></video>-->
            <!--                  </a-col>-->
            <!--                </a-row>-->
            <!--                <a-row style="margin-top: 10px">-->
            <!--                  <a-col class="editAudio" :span="6" v-for="(item, index) in act.audioList" :key="index">-->
            <!--                    <audio class="editvideoPlay" style="outline-style: none;" controlslist="nodownload"-->
            <!--                           :src="resBaseVideo + '/' + item.path" controls="controls" poster="">-->
            <!--                    </audio>-->
            <!--                  </a-col>-->
            <!--                </a-row>-->
            <!--              </a-row>-->
            <!--            </a-col>-->
          </li>
        </ul>
        <div class="task-status">
          <div class="status-l">
            <span class="zt">状态：</span>
            <span class="sy">{{ format.permission(item.permission) }}</span>
          </div>
          <div class="status-r">
            <span @click="edit(item)" :class="item.isPublish===1?'feedBack-no':''">编辑</span>
            <span @click="delTask(item)" :class="item.isPublish===1?'feedBack-no':''">删除</span>
            <span :class="item.isPublish===0?'feedBack-no':''" @click="taskFeedbackFun(item)">任务反馈</span>
            <span @click="publish(item)"
                  :class="item.isPublish===1?'feedBack-no':''">{{ item.isPublish == 0 ? '发布' : '已发布' }}</span>
          </div>
        </div>
      </li>
    </ul>
    <a-empty v-if="taskList&&taskList.length === 0"/>

    <!--添加学习任务弹窗-->
    <div v-if="addTaskVis">
      <a-modal title="添加学习任务" :visible="addTaskVis" destroyOnClose @cancel="taskCancel" width="1100px" footer="">
        <div class="task-top">
          <span class="xing">*</span>
          <span class="text"> 状态：</span>
          <a-select default-value="私有" style="width: 180px" @change="taskStatusChange">
            <a-select-option value="2">私有</a-select-option>
            <a-select-option value="1">公开</a-select-option>
          </a-select>
        </div>
        <div class="task-in">
          <a-textarea v-model="addActivityParam.content" @change="addTitleChange" placeholder="请输入任务内容..."
                      :auto-size="{ minRows: 3, maxRows: 5 }"/>
        </div>
        <div class="add-activity">
          <ul>
            <li class="activi-li" v-for="(item,index) in addActivityParam.activityList" :key="index">
              <div class="activity-name">
                <span class="act-name">活动{{ format.number2Text(index) }}</span>
                <img src="../../../../assets/image/task_add.png" class="task_add" @click="addActFun()"/>
                <img src="../../../../assets/image/task_delete.png" class="task_delete" @click="delFun(index)"/>
              </div>
              <div class="activity-type">
                <div class="read-left">
                  <span class="xing">*</span>
                  <span class="text"> 活动类型：</span>
                  <a-select placeholder="请选择活动类型" v-model="item.activityStyle" default-value="写作"
                            style="width: 180px" @change="statusChange">
                    <a-select-option :value="t.type" v-for="(t,index) in activityListType" :key="index">
                      {{ t.name }}
                    </a-select-option>
                  </a-select>
                </div>
                <div class="read-right" v-if="item.activityStyle==9">
                  <span class="xing">*</span>
                  <span class="text"> 类型名称：</span>
                  <a-input placeholder="请输入活动类型" style="width: 360px"
                           v-model="item.activityStyleCustomName"></a-input>
                </div>
              </div>
              <div class="read-type" v-if="item.activityStyle==6">
                <div class="read-left">
                  <span class="xing">*</span>
                  <span class="text"> 阅读分类：</span>
                  <a-select placeholder="请选择活动类型" default-value="原文阅读" style="width: 180px"
                            @change="readTypeChange($event,item)" v-model="item.relatedReadType">
                    <a-select-option :value="t.id" v-for="(t,index) in readList" :key="index">
                      {{ t.name }}
                    </a-select-option>
                  </a-select>
                </div>
                <div class="read-right">
                  <span class="xing">*</span>
                  <span class="text"> 文章</span>
                  <!--                  <mySelect @getMess="getMessFun" v-model="bookList" v-if="hackReset"/>-->
                  <a-select
                      mode="multiple"
                      style="width: 360px;margin-left:20px;"
                      placeholder="请选择课文"
                      option-label-prop="label"
                      @change="getMessFun($event,item)"
                      showSearch
                      allowClear
                  >
                    <a-select-option :value="book.id" :label="book.title" v-for="book in bookList" :key="book.id">
                      {{ book.title }}
                    </a-select-option>
                  </a-select>
                </div>
              </div>
              <TinyEditor v-if="hackEditor" v-model="item.activityContent" :key="tinymceAddFlag"
                          :value="item.activityContent"></TinyEditor>

              <div class="imgList">
                <div class="newImg" :span="8" v-for="(item, i) in item.imageList" :key="i">
                  <img width="100px" height="80px" :src="resBasePath + '/' + item.path" alt=""/>
                  <img class="del" @click="addDelImg(i,index)" src="../../../../assets/image/27.png" alt="">
                </div>
                <div class="editVideo" v-for="(item, j) in item.videoList" :key="j">
                  <video class="editvideoPlay" style="outline-style: none;" controlslist="nodownload"
                         :disablePictureInPicture="true" :src="resBaseVideo + '/' + item.path"
                         controls="controls"
                         :poster="item.coverPath && item.coverPath != null ? item.coverPath : '@/assets/imgs/video.png'"></video>
                  <img class="del" @click="addDelVideo(j,index)" src="../../../../assets/image/27.png" alt=""/>
                </div>
                <div class="editAudio" v-for="(it, k) in item.audioList" :key="k">
                  <!--                    <audio class="editvideoPlay" style="outline-style: none;" controlslist="nodownload"-->
                  <!--                           :src="resBaseVideo + '/' + item.path" controls="controls" poster="">-->
                  <!--                    </audio>-->
                  <img width="100px" height="100px" src="../../../../assets/imgs/audio.png" @click="playSound(it)"
                       alt=""/>
                  <img class="del" @click="addDelAudio(k,index)" src="../../../../assets/image/27.png" alt=""/>
                </div>
                <img src="../../../../assets/image/task_add_img.png" class="task_add_img"
                     @click="editUpLoadLib(item)"/>

                <!--                <a-row class="imgList">-->
                <!--                  <a-col>-->
                <!--                    <div v-if="item.imageList.length > 0">-->
                <!--                      <a-row>-->
                <!--                        <a-col class="newImg" :span="8" v-for="(item, i) in item.imageList" :key="i">-->
                <!--                          <img width="200px" height="100px" :src="resBasePath + '/' + item.path" alt=""/>-->
                <!--                          <img class="del" @click="addDelImg(i,index)" src="../../../../assets/image/27.png" alt="">-->
                <!--                        </a-col>-->
                <!--                      </a-row>-->
                <!--                    </div>-->
                <!--                    <div v-if="item.videoList.length > 0">-->
                <!--                      <a-row>-->
                <!--                        <a-col class="editVideo" v-for="(item, j) in item.videoList" :key="j">-->
                <!--                          <video class="editvideoPlay" style="outline-style: none;" controlslist="nodownload"-->
                <!--                                 :disablePictureInPicture="true" :src="resBaseVideo + '/' + item.path"-->
                <!--                                 controls="controls"-->
                <!--                                 :poster="item.coverPath && item.coverPath != null ? item.coverPath : '@/assets/imgs/video.png'"></video>-->
                <!--                          <img class="del" @click="addDelVideo(j,index)" src="../../../../assets/image/27.png" alt=""/>-->
                <!--                        </a-col>-->
                <!--                      </a-row>-->
                <!--                    </div>-->
                <!--                    <div v-if="item.audioList.length > 0">-->
                <!--                      <a-row>-->
                <!--                        <a-col class="editAudio" v-for="(item, k) in item.audioList" :key="k">-->
                <!--                          <audio class="editvideoPlay" style="outline-style: none;" controlslist="nodownload"-->
                <!--                                 :src="resBaseVideo + '/' + item.path" controls="controls" poster="">-->
                <!--                          </audio>-->
                <!--                          <img class="del" @click="addDelAudio(k,index)" src="../../../../assets/image/27.png" alt=""/>-->
                <!--                        </a-col>-->
                <!--                      </a-row>-->
                <!--                    </div>-->
                <!--                  </a-col>-->
                <!--                </a-row>-->
                <!--                <img src="../../../../assets/image/task_add_img.png" class="task_add_img"-->
                <!--                     @click="editUpLoadLib(item)"/>-->
              </div>
            </li>
          </ul>
        </div>
        <div class="f-del mt20">
          <div class="f-c" @click="taskCancel">取消</div>
          <div class="f-s" @click="taskSure">确认</div>
        </div>
      </a-modal>
    </div>
    <!--编辑学习任务弹窗-->
    <a-modal title="编辑学习任务" :visible="editTaskVis" :destroyOnClose=true @cancel="taskEditCancel" width="1100px"
             footer="">
      <div class="task-top">
        <span class="xing">*</span>
        <span class="text"> 状态：</span>
        <a-select :default-value="format.permission(editTaskMess.viewPermission)" style="width: 180px"
                  @change="editTaskStatus">
          <a-select-option value="2">私有</a-select-option>
          <a-select-option value="1">公开</a-select-option>
        </a-select>
      </div>
      <div class="task-in">
        <a-textarea v-model="editTaskMess.content" placeholder="请输入任务内容..."
                    :auto-size="{ minRows: 3, maxRows: 5 }"/>
      </div>
      <div class="add-activity" v-if="editTaskMess.activityList">
        <ul>
          <li class="activi-li" v-for="(item,index) in editTaskMess.activityList" :key="index">
            <div class="activity-name">
              <span class="act-name">活动{{ format.number2Text(index) }}</span>
              <img src="../../../../assets/image/task_add.png" class="task_add" @click="editAddActFun()"/>
              <img src="../../../../assets/image/task_delete.png" class="task_delete" @click="editDelFun(index)"/>
            </div>
            <div class="activity-type">
              <div class="read-left">
                <span class="xing">*</span>
                <span class="text"> 活动类型：</span>
                <a-select placeholder="请选择活动类型" style="width: 180px" @change="editStatusChange"
                          v-model="item.activityStyle">
                  <a-select-option :value="t.type" v-for="(t,index) in activityListType" :key="index">
                    {{ t.name }}
                  </a-select-option>
                </a-select>
              </div>
              <div class="read-right" v-if="item.activityStyle==9">
                <span class="xing">*</span>
                <span class="text"> 类型名称：</span>
                <a-input placeholder="请输入活动类型" style="width: 360px" v-model="item.activityStyleCustomName">
                </a-input>
              </div>
            </div>
            <div class="read-type" v-if="item.activityStyle==6">
              <div class="read-left">
                <span class="xing">*</span>
                <span class="text"> 阅读分类：</span>
                <a-select placeholder="请选择阅读类型" :default-value="format.formatReadType(item.relatedReadType)"
                          style="width: 180px"
                          @change="readTypeChange($event,item)" v-model="item.relatedReadType">
                  <a-select-option :value="t.id" v-for="(t,index) in readList" :key="index">
                    {{ t.name }}
                  </a-select-option>
                </a-select>
              </div>
              <div class="read-right">
                <span class="xing">*</span>
                <span class="text"> 文章</span>
                <!--                <mySelect @getMess="getMessFun(item)" v-model="bookList" v-if="hackReset"/>-->
                <a-select
                    mode="multiple"
                    style="width: 360px;margin-left:20px;"
                    placeholder="请选择课文"
                    option-label-prop="label"
                    @change="getMessFun($event,item)"
                    v-model="item.relatedReadSimplesArray"
                    showSearch
                    allowClear
                >
                  <a-select-option :value="book.id" :label="book.title" v-for="book in bookList" :key="book.id"
                  >
                    {{ book.title }}
                  </a-select-option>

                </a-select>
              </div>
            </div>
            <div>
              <TinyEditor v-if="hackEditEditor" v-model="item.activityContent" :key="tinymceFlag"
                          :value="item.activityContent"></TinyEditor>
            </div>
            <div>
              <div class="imgList">
                <div class="newImg" :span="8" v-for="(item, i) in item.imageList" :key="i">
                  <img width="100px" height="80px" :src="resBasePath + '/' + item.path" alt=""/>
                  <img class="del" @click="editDelImg(i,index)" src="../../../../assets/image/27.png" alt="">
                </div>
                <div class="editVideo" v-for="(item, j) in item.videoList" :key="j">
                  <video class="editvideoPlay" style="outline-style: none;" controlslist="nodownload"
                         :disablePictureInPicture="true" :src="resBaseVideo + '/' + item.path"
                         controls="controls"
                         :poster="item.coverPath && item.coverPath != null ? item.coverPath : '@/assets/imgs/video.png'"></video>
                  <img class="del" @click="editdelVideo(j,index)" src="../../../../assets/image/27.png" alt=""/>
                </div>
                <div class="editAudio" v-for="(it, k) in item.audioList" :key="k">
                  <!--                  <audio class="editvideoPlay" style="outline-style: none;" controlslist="nodownload"-->
                  <!--                         :src="resBaseVideo + '/' + item.path" controls="controls" poster="">-->
                  <!--                  </audio>-->
                  <img width="100px" height="100px" src="../../../../assets/imgs/audio.png" @click="playSound(it)"
                       alt=""/>
                  <img class="del" @click="editDelAudio(k,index)" src="../../../../assets/image/27.png" alt=""/>
                </div>
                <img src="../../../../assets/image/task_add_img.png" class="task_add_img"
                     @click="editUpLoadLib(item)"/>
              </div>
              <!--              <a-row class="imgList">-->
              <!--                <a-col>-->
              <!--                  <div v-if="item.imageList.length > 0">-->
              <!--                    <a-row>-->
              <!--                      <a-col class="newImg" :span="8" v-for="(item, i) in item.imageList" :key="i">-->
              <!--                        <img width="200px" height="100px" :src="resBasePath + '/' + item.path" alt=""/>-->
              <!--                        <img class="del" @click="editDelImg(i,index)" src="../../../../assets/image/27.png" alt="">-->
              <!--                      </a-col>-->
              <!--                    </a-row>-->
              <!--                  </div>-->
              <!--                  <div v-if="item.videoList.length > 0">-->
              <!--                    <a-row>-->
              <!--                      <a-col class="editVideo" v-for="(item, j) in item.videoList" :key="j">-->
              <!--                        <video class="editvideoPlay" style="outline-style: none;" controlslist="nodownload"-->
              <!--                               :disablePictureInPicture="true" :src="resBaseVideo + '/' + item.path"-->
              <!--                               controls="controls"-->
              <!--                               :poster="item.coverPath && item.coverPath != null ? item.coverPath : '@/assets/imgs/video.png'"></video>-->
              <!--                        <img class="del" @click="editdelVideo(j,index)" src="../../../../assets/image/27.png" alt=""/>-->
              <!--                      </a-col>-->
              <!--                    </a-row>-->
              <!--                  </div>-->
              <!--                  <div v-if="item.audioList.length > 0">-->
              <!--                    <a-row>-->
              <!--                      <a-col class="editAudio" v-for="(item, k) in item.audioList" :key="k">-->
              <!--                        <audio class="editvideoPlay" style="outline-style: none;" controlslist="nodownload"-->
              <!--                               :src="resBaseVideo + '/' + item.path" controls="controls" poster="">-->
              <!--                        </audio>-->
              <!--                        <img class="del" @click="editDelAudio(k,index)" src="../../../../assets/image/27.png" alt=""/>-->
              <!--                      </a-col>-->
              <!--                    </a-row>-->
              <!--                  </div>-->
              <!--                </a-col>-->
              <!--              </a-row>-->

            </div>
          </li>
        </ul>
      </div>
      <div class="f-del mt20">
        <div class="f-c" @click="taskEditCancel">取消</div>
        <div class="f-s" @click="taskEditSure">确认</div>
      </div>
    </a-modal>
    <file-preview :visible.sync="preAudioVisible" v-if="preAudioVisible" :file="previewFile"
                  title="音频预览"></file-preview>
    <!--发布任务-->
    <div v-if="publishVis">
      <a-modal title="发布任务" :visible="publishVis" :destroyOnClose=true @cancel="pubCancel" width="400px" footer="">
        <div class="publish-task">
          <a-row class="publish-time">
            <a-col class="l" :span="7" style="margin-top: 6px;">
              截止时间：
            </a-col>
            <a-col class="r" :span="13">
              <a-date-picker style="margin-left: 2px;" :disabledDate="disabledDate" show-time
                             placeholder="请选择截止时间"
                             @change="timeChange" @ok="timeOk"/>
              <a-tooltip placement="top">
                <template slot="title">
                  <div v-html="remendText"></div>
                </template>
                <img class="remend" src="../../../../assets/image/remend.png" alt=""/>
              </a-tooltip>
            </a-col>
          </a-row>
          <a-row class="publish-top">
            <a-col class="l" :span="7">发布至：</a-col>
            <a-col class="r" :span="15">
              <!-- <span class="currentTypeAct">班级</span> -->
              <span :class="currentTypeIndex==index?'currentTypeAct':'currentType'" @click="changeType(item,index)"
                    v-for="(item,index) in taskTypeList" :key="index">{{ item.name }}</span>
            </a-col>
          </a-row>
          <a-row class="publish-bot">
            <a-col class="l" :span="7">选择发布：</a-col>
            <a-col class="r" :span="14" v-if="classData&&classData.length>0">
              <a-checkbox-group v-model='allClassIds' v-if="currentTypeIndex == 0" @change="checkClass">
                <div class="classSelect" v-for="(item, index) in classData" :key="index">
                  <a-checkbox :value="item.id">{{ item.className }}</a-checkbox>
                </div>
              </a-checkbox-group>
              <a-tree v-if="currentTypeIndex==1" checkable show-icon @check="onCheck" :replace-fields="replaceFields"
                      :tree-data='treeData' :load-data="getV2Group">
                <a-icon slot="switcherIcon" type="down"/>
              </a-tree>
            </a-col>
            <a-col class="r" :span="14" v-if="classData.length==0">
              <div style="margin-top: 10px;color: #666;">暂无班级群组数据</div>
            </a-col>
          </a-row>
          <div class="f-del mt20">
            <div class="f-c" @click="pubCancel">取消</div>
            <div class="f-s" @click="pubSure">确认</div>
          </div>
        </div>
      </a-modal>
    </div>
    <!--删除任务-->
    <a-modal v-model="delVisible" width="400px" footer="" title="删除确认">
      <div class="del-m">
        <div class="del-t">删除后，学习任务不可恢复？</div>
        <div class="del-s">确定删除？</div>
        <div class="f-del mt20">
          <div class="f-c" @click="() => {this.delVisible = false}">取消</div>
          <div class="f-s" @click="delOk">确认</div>
        </div>
      </div>
    </a-modal>
    <!--资源库弹窗-->
    <div v-if="libraryVis">
      <a-modal title="资源" :visible="libraryVis" :zIndex=1001 destroyOnClose footer="" width="950px"
               :confirm-loading="confirmLoading" @cancel="libraryCancel">
        <div class="mainLib">
          <!-- <a-spin class="load" v-show="loading" /> -->
          <div class="sureNum">已选{{ savecheckImg.length + savecheckVideo.length + savecheckAudio.length }}项
          </div>
          <div class="sureImg" @click="sureImg()">使用</div>
          <div class="search">
            <a-input-search v-model="searchName" placeholder="输入搜索内容" enter-button @search="onSearch"/>
          </div>
          <div class="tabList">
            <a-tabs default-active-key="1" @change="tabList">
              <a-tab-pane key="1" tab="图片">
                <a-checkbox-group v-model="savecheckImg" @change="checkedImg">
                  <ul>
                    <li class="uploadLi" @click="uploadPhotoLi"></li>
                    <li v-for="(item, index) in dataList" :key="index">
                      <template>
                        <div class="imgTop">
                          <img slot="extra" :src="resBasePath + '/' + item.filePath" alt=""/>
                        </div>
                        <div class="imgBot">
                          <span class="imgName">{{ item.fileName || '图片' + index }}</span>
                          <a-checkbox :value="item.filePath"></a-checkbox>
                          <!-- <span class="imgDel" @click="delPhoto(item.id)"> <a-icon type="delete" /> </span> -->
                        </div>
                      </template>
                    </li>
                  </ul>
                </a-checkbox-group>
              </a-tab-pane>
              <a-tab-pane key="2" tab="视频" force-render>
                <a-checkbox-group v-model="savecheckVideo" @change="checkedVideoListFun">
                  <ul>
                    <li class="uploadLi" @click="uploadPhotoLi"></li>
                    <li v-for="(item, index) in dataList" :key="index">
                      <template>
                        <div class="imgTop">
                          <video class="video" :src="resBaseVideo + '/' + item.filePath" controls="controls"
                                 controlslist="nodownload" poster=""></video>
                        </div>
                        <div class="imgBot">
                          <span class="imgName">{{ item.fileName || '视频' + index }}</span>
                          <a-checkbox :value="item.filePath"></a-checkbox>
                        </div>
                      </template>
                    </li>
                  </ul>
                </a-checkbox-group>
              </a-tab-pane>
              <a-tab-pane key="5" tab="音频">
                <a-checkbox-group v-model="savecheckAudio" @change="checkedAudioListFun">
                  <ul>
                    <li class="uploadLi" @click="uploadPhotoLi"></li>
                    <li v-for="(item, index) in dataList" :key="index">
                      <template>
                        <div class="imgTop">
                          <video class="video" controlslist="nodownload"
                                 :src="resBaseVideo + '/' + item.filePath" controls="controls"
                                 poster=""></video>
                        </div>
                        <div class="imgBot">
                          <span class="imgName">{{ item.fileName || '音频' + index }}</span>
                          <a-checkbox :value="item.filePath"></a-checkbox>
                          <!-- <span @click="delVideo(item.id)" class="imgDel">
                        <a-icon type="delete" />
                      </span> -->
                        </div>
                      </template>
                    </li>
                  </ul>
                </a-checkbox-group>
              </a-tab-pane>
            </a-tabs>
          </div>
        </div>
      </a-modal>
    </div>
    <!--点击上传资源弹窗-->
    <a-modal title="添加资源" :visible="uploadShowVis" destroyOnClose :zIndex=1003 footer="" width="450px"
             :confirm-loading="confirmLoading" @cancel="uploadShowCancel">
      <a-row style="min-height:120px;line-height:30px;">
        <!-- <a-col :span="4">
            名称:
          </a-col> -->
        <a-col :span="24">
          <!-- <a-input v-model="photoName" placeholder="请输入内容名称" /> -->
          <div class="photoUpload">
            <a-upload action="" list-type="picture-card" :show-upload-list="true" @preview="handlePreview"
                      :before-upload="beforeUpload1" @change="handleChange">
              <div class="ant-upload-text">上传</div>
            </a-upload>
            <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
              <img alt="example" style="width: 100%" :src="previewImage"/>
            </a-modal>
          </div>
        </a-col>
      </a-row>
    </a-modal>
    <!--相关阅读文章详情-->
    <a-modal title="" :visible="ralatedReadVisible" @cancel="ralatedReadVisible = false" :footer="null"
             :destroyOnClose="true" width="1000px" centered>
      <div class="relatedReadInfo-content scroll">
        <h3 class="relatedReadInfo-title">{{ relatedReadInfo.title }}</h3>
        <p class="relatedReadInfo-author">{{ relatedReadInfo.author }}</p>
        <div v-if="false" class="prev" @click="goto(-1)">上一篇</div>
        <div v-if="false" class="next" @click="goto(1)">下一篇</div>
        <vue-pdf-embed v-for="(item,idx) in relatedReadInfo.fileList" :key="idx"
                       :source="($resBasePath + item.path)"/>
        <div v-for="(item, index) in relatedReadInfo.info" :key="index">
          <p :style="{ 'text-indent': '2em', 'line-height': '2em', 'text-align': item.align }">
            {{ item.content }}</p>
          <ts-video v-if="item.videoList" ref="myVideo" :videos="item.videoList">
          </ts-video>
          <a-carousel v-if="item.imageList" arrows>
            <div slot="prevArrow" class="custom-slick-arrow" style="left: 10px;zIndex: 1">
              <a-icon type="left-circle"/>
            </div>
            <div slot="nextArrow" class="custom-slick-arrow" style="right: 10px">
              <a-icon type="right-circle"/>
            </div>
            <div v-for="img in item.imageList" :key="img.id" style="text-align:center">
              <img style="height:400px;max-width:100%;margin:auto" :src="$resBasePath + img.path"/>
              <p class="title" v-if="img.name">{{ img.name }}</p>
            </div>
          </a-carousel>
          <template v-if="item.audioList">
            <div v-for="audio in item.audioList" style="text-align: center;" :key="audio.id">
              <audio controls :src="$resBasePath + audio.path"></audio>
              <p v-if="audio.name">{{ audio.name }}</p>
            </div>
          </template>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import requestUrl from '@/utils/requestUrl.js'
import format from '@/utils/format.js'
import mySelect from '../../components/Aselect.vue'
import TinyEditor from '@/components/TinyEditor.vue'
import moment from 'moment'
import axios from 'axios'
import RichTextView from '../../../../components/richTextView.vue'
import FilePreview from '../../../../components/FilePreview.vue'

export default {
  name: 'StudyTask',
  data () {
    return {
      requestUrl,
      format,
      delVisible: false,
      ralatedReadVisible: false,
      delMess: {},
      relatedReadInfo: {},
      access_token: this.$getUserInfo().access_token || localStorage.getItem('access_token'),
      id: '', // 任务id，保存任务时传null或不传
      styleId: localStorage.getItem('styleId'),
      bookId: localStorage.getItem('syzg-bookId'),
      resBasePath: this.$resBasePath,
      resBaseVideo: this.$resBaseVideo,
      title: '', // 任务标题
      content: '', // 任务内容
      taskType: 1, // 1 班级任务 2 小组任务
      ifOptional: 0, // 任务是否必做 0 否 1 是 默认0
      taskStyle: '', // 1：写作 2：录音 3：视频制作 4：拍照 5：绘画 6：阅读 7：习题 8 批注 9 习题
      teacherId: this.$getUserInfo().id, // 教师id
      isPublish: 0, // 是否发布 1是 0否
      publishTypeNum: 1, // 1发布的班级 2发布的小组
      school: '', // 教师所在学校
      addActivityParam: {}, // 新建学习任务
      activityListType: [
        { name: '写作', type: 1 },
        { name: '录音', type: 2 },
        { name: '视频', type: 3 },
        { name: '拍照', type: 4 },
        { name: '绘画', type: 5 },
        { name: '阅读', type: 6 },
        { name: '习题', type: 7 },
        { name: '批注', type: 8 },
        { name: '其它', type: 9 }
      ],
      editTaskMess: {},
      publishVis: false,
      taskTypeList: [
        { name: '班级', type: 1 },
        { name: '小组', type: 2 }
      ],
      currentTypeIndex: 0,
      classData: [],
      allClassIds: [],
      replaceFields: {
        children: 'groupList',
        title: 'className',
        key: 'id'
      },
      readList: [{ name: '原文阅读', id: 1 }, { name: '鉴赏阅读', id: 2 }, { name: '互文比读', id: 3 }],
      readFlag: false,
      inputFlag: false,
      hackReset: true,
      // 阅读类型
      bookList: [],
      checkBookList: '',
      taskList: [],
      addTaskVis: false,
      editTaskVis: false,
      editContent: '',
      remendText: '到截止时间后，学生仍可以提交，系统会标识出超时提交者。',
      timeDate: '',
      publishMess: '', // 要发布的信息
      classIds: [], // 班级集合
      checkClassIds: [], // 选择的班级ID
      groupIds: [], // 群组集合
      allSelectedNodes: [],
      pageSize: 10,
      pageNum: 1,
      total: 0,
      contentFlag: true,
      hackEditor: false, // 富文本默认销毁
      hackEditEditor: false, // 富文本默认销毁
      studyTask: {
        name: '学习任务',
        route: 'StudyTask'
      },
      studySelect: {
        name: '历史记录',
        route: 'StudyTaskHistory'
      },
      readType: 1,
      tinymceFlag: 1,
      tinymceAddFlag: 1,
      libraryVis: false,
      confirmLoading: false,
      imgTrans: [], // 添加转图片为数组
      videoTrans: [], // 添加转视频为数组
      audioTrans: [], // 添加转音频为数组
      editimgTrans: [], // 编辑转图片为数组
      editvideoTrans: [], // 编辑转视频为数组
      editaudioTrans: [], // 编辑转音频为数组
      savecheckImg: [], // 暂存选择的图片
      savecheckVideo: [], // 暂存选择的视频
      savecheckAudio: [], // 暂存选择的音频
      searchName: '', // 搜索名称
      dataList: [], // 资源列表
      uploadShowVis: false, // 上传图片弹窗
      previewImage: '',
      previewVisible: false,
      preAudioVisible: false, // 音频预览
      checkImgList: [], // 选择的图片
      checkVideoList: [], // 选择的视频
      checkAudioList: [], // 选择的音频
      addType: '1', // 添加资源根据类型添加
      classId: '', //
      coverImg: require('@/assets/imgs/video.png'),
      currentActivityList: {}, // 新建学习任务-当前活动
      editActivityList: {}, // 新建学习任务-当前活动
      previewFile: {}, // 新建学习任务-当前活动
      treeData: [] // 发布任务-小组数据
      // showWangFlag: true
    }
  },
  mounted () {
    this.getTaskActivityStyleList()
    this.getList()
    this.getClassData()
    this.getRelatedReadTitleListByReadType()
  },
  methods: {
    addTitleChange (e) {
      this.addActivityParam.content = e.target.value
    },
    handleListChange (current, pageSize) {
      this.pageNum = current
      this.pageSize = pageSize
      this.getList()
    },
    onCheck (selectedKeys) {
      this.allSelectedNodes = selectedKeys
      this.checkClassIds = this.classData.map(item => {
        return item.id
      })
    },
    getMessFun (e, item) {
      console.log('getMessFun', 'getMessFun')
      console.log(e)
      item.relatedReadSimplesArray = e
      let checkBookList = ''
      checkBookList += e + ','
      // 获取课文id值
      checkBookList = checkBookList.slice(0, checkBookList.length - 1)
      this.checkBookList = checkBookList
      item.relatedReadId = checkBookList
      // item.relatedReadSimplesArray = checkBookList.join(',').split(',')
      console.log(this.checkBookList)
      console.log(item)
      // console.log('relatedReadType',item.relatedReadType)
    },
    showTip () {
      this.$message.warning('已超出最大学习任务数10条，请删除后引用该任务')
    },
    initAddActivityParam () {
      this.addActivityParam = {}
      this.addActivityParam = {
        access_token: this.$getUserInfo().access_token,
        id: '',
        styleId: localStorage.getItem('styleId'),
        bookId: localStorage.getItem('syzg-bookId'),
        content: '',
        activityName: '',
        testContentId: '',
        ifOptional: 0,
        taskType: 1,
        viewPermission: 2,
        teacherId: this.teacherId,
        activityList: [
          {
            id: '',
            activityName: '',
            activityContent: '',
            activityStyle: 1,
            testContentId: '',
            relatedReadId: '',
            activityStyleCustomName: '',
            readFlag: false,
            readType: 1,
            imageList: [],
            audioList: [],
            videoList: []
          }
        ]
      }
      this.tinymceAddFlag++
      this.tinymceFlag++
      this.addType = '1'
      this.checkImgList = []
      this.checkVideoList = []
      this.checkAudioList = []
    },
    add () {
      // 显示添加学习任务弹框
      if (this.total >= 10) {
        this.$message.warning('任务最多有10条')
        return
      }
      this.initAddActivityParam()
      this.addTaskVis = true
      setTimeout(() => {
        this.hackEditor = true
      }, 400)
    },
    taskCancel () {
      // 隐藏学习任务弹框
      this.addTaskVis = false
      this.hackEditor = false
      this.addActivityParam = []
    },
    taskSure () {
      // 添加学习任务
      if (this.addActivityParam.content === '') {
        this.$message.warning('缺少任务内容')
        this.contentFlag = false
        return
      }
      if (this.addActivityParam.activityList.length === 0) {
        this.$message.warning('任务下需要有活动')
        this.contentFlag = false
        return
      }
      this.addActivityParam.activityList.find(item => {
        if (item.activityContent === '') {
          this.$message.warning('活动内容不能为空')
          this.contentFlag = false
        } else {
          this.contentFlag = true
        }
      })
      if (this.contentFlag) {
        this.$http.post(requestUrl.addOrModifyTask, this.addActivityParam).then(res => {
          if (res) {
            this.$nextTick(() => {
              this.getList()
              this.addTaskVis = false
              this.initAddActivityParam()

              this.tinymceAddFlag++
              setTimeout(() => {
                this.hackEditor = false
              }, 400)
            })
          }
        })
      }
    },
    taskEditCancel () {
      this.editTaskVis = false
      this.hackEditEditor = false
    },
    taskEditSure () {
      // 编辑学习任务提交
      if (this.editTaskMess.content === '') {
        this.$message.warning('缺少任务内容')
        this.contentFlag = false
        return
      }
      if (this.editTaskMess.activityList.length === 0) {
        this.$message.warning('任务下需要有活动')
        this.contentFlag = false
        return
      }
      this.editTaskMess.activityList.find(item => {
        if (item.activityContent === '') {
          this.$message.warning('活动内容不能为空')
          this.contentFlag = false
        } else {
          this.contentFlag = true
        }
      })
      if (this.editTaskMess.activityList) {
        this.editTaskMess.activityList.forEach(item => {
          item.readType = item.relatedReadType
        })
      }

      this.editTaskMess.access_token = this.access_token
      this.editTaskMess.teacherId = this.teacherId
      this.$http.post(requestUrl.addOrModifyTask, this.editTaskMess).then(res => {
        this.$nextTick(() => {
          this.getList()
          this.editTaskVis = false
          this.hackEditEditor = false
        })
      })
    },
    taskStatusChange (e) {
      this.addActivityParam.viewPermission = e
    },
    editTaskStatus (e) {
      this.editTaskMess.viewPermission = e
    },
    statusChange (e) {
      this.readFlag = e === 6
      this.inputFlag = e === 9
    },
    readTypeChange (e, item) {
      console.log('relatedReadType', e)
      this.readType = e
      this.relatedReadType = e
      item.readType = e
      item.relatedReadType = e
      this.getRelatedReadTitleListByReadType(false, item)
      // this.hackReset = false // 销毁组件
      // this.$nextTick(() => {
      //   this.hackReset = true // 重建组件
      // })
    },
    editStatusChange (e) {

    },
    change (e) {
      console.log()
    },
    getValue (data) {
      console.log(data)
    },
    activityFun (num) {
      this.editCurrent = num
    },
    addActFun () {
      // 增加学习任务-活动
      if (this.addActivityParam.activityList.length >= 5) {
        this.$message.warning('最多只能添加5个活动')
      } else {
        this.tinymceAddFlag++
        this.$nextTick(() => {
          this.addActivityParam.activityList.push({
            id: '',
            activityName: '',
            activityContent: '',
            activityStyle: 1,
            testContentId: '',
            relatedReadId: '',
            activityStyleCustomName: '',
            readFlag: false,
            readType: 1,
            imageList: [],
            audioList: [],
            videoList: []
          })
        })
      }
    },
    editAddActFun () {
      // 编辑学习任务--添加
      console.log(this.editTaskMess.activityList)
      if (this.editTaskMess.activityList.length > 5) {
        this.$message.warning('最多只能添加5个活动')
      } else {
        this.tinymceFlag++
        this.$nextTick(() => {
          this.editTaskMess.activityList.push({
            id: '',
            activityName: '',
            activityContent: '',
            activityStyle: 1,
            testContentId: '',
            detailContent: '',
            relatedReadId: '',
            activityStyleCustomName: '',
            relatedReadType: 1,
            relatedReadContent: '',
            readFlag: false,
            readType: 1,
            relatedReadSimples: [],
            relatedReadSimplesArray: [],
            imageList: [],
            audioList: [],
            videoList: []
          })
        })
        setTimeout(() => {
          this.hackEditor = true
        }, 400)
      }
    },
    delTask (item) {
      // 显示删除学习任务弹框
      // if (item.isPublish === 0) {
      this.delMess = item
      this.delVisible = true
      // }
    },
    ralatedRead (item) {
      // 显示相关阅读弹框
      this.$http.post(requestUrl.getRelatedReadDetail, {
        access_token: this.access_token,
        id: item.id
      }).then(res => {
        if (res) {
          this.relatedReadInfo = res
          const infos = this.relatedReadInfo?.info.map((info) => {
            let align = 'justify'
            if (info.formatType === 2) {
              align = 'center'
            } else if (info.formatType === 3) {
              align = 'right'
            }
            return {
              ...info,
              align
            }
          })
          this.relatedReadInfo.info = infos
          this.ralatedReadVisible = true
        }
      })
      // }
    },
    delOk () {
      // 删除学习任务
      this.$http.post(requestUrl.deleteTaskByTaskId, {
        access_token: this.access_token,
        id: this.delMess.id
      }).then(res => {
        if (res) {
          this.$nextTick(() => {
            this.getList()
            this.delVisible = false
          })
        }
      })
    },
    edit (item) {
      // 编辑学习任务
      if (item.isPublish === 0) {
        this.addType = '2'
        if (item.activityList) {
          item.activityList.forEach(itemValue => {
            if (itemValue.relatedReadSimples) {
              itemValue.relatedReadSimplesArray = itemValue.relatedReadSimples.map(function (ite) {
                return ite.id
              })
            }
          })
        }
        this.editTaskMess = JSON.parse(JSON.stringify(item))
        if (this.editTaskMess.permission == null) {
          this.editTaskMess.viewPermission = 2
        } else {
          this.editTaskMess.viewPermission = this.editTaskMess.permission
        }

        this.editTaskVis = true

        setTimeout(() => {
          this.hackEditEditor = true
        }, 400)
        this.showWangFlag = true
        console.log(this.editTaskMess)
      }
      //   if (item.activityList) {
      //   item.activityList.forEach(itemValue => {
      //     itemValue.activityStyle = this.format.taskStyle(itemValue.activityStyle)
      //   })
      //   this.editTaskMess.id = item.id
      // }
    },
    // editFun(index){
    //   this.showWangFlag = false
    // },
    delFun (index) {
      console.log(index)
      if (this.addActivityParam.activityList.length > 1) {
        this.addActivityParam.activityList.splice(index, 1)
      } else {
        this.$message.warning('任务下不能没有活动')
      }
    },
    editDelFun (index) {
      if (this.editTaskMess.activityList.length > 1) {
        this.editTaskMess.activityList.splice(index, 1)
      } else {
        this.$message.warning('任务下不能没有活动')
      }
    },
    taskFeedbackFun (item) {
      if (item.isPublish === 1) {
        console.log(item)
        this.$store.commit('setTaskFeedBackMess', item)
        this.$router.push({ name: 'taskFeedBack' })
      }
    },
    getList () {
      // 获取老师备课任务列表
      const param = {
        bookId: this.bookId,
        styleId: this.styleId,
        teacherId: this.teacherId,
        access_token: this.access_token,
        pageSize: this.pageSize,
        pageNum: this.pageNum
      }
      this.$http.post(requestUrl.getTeacherTask, param).then(res => {
        console.log(res)
        if (res) {
          this.taskList = res.list || []
          this.total = this.taskList.length
          // 学习任务类型为阅读时，获取阅读任务的内容
          for (let i = 0; i < this.taskList.length; i++) {
            const activityList = this.taskList[i].activityList
            for (let j = 0; j < activityList.length; j++) {
              const activityStyle = activityList[j].activityStyle
              if (activityStyle === 6) {
                const relatedReadType = activityList[j].readType
                // activityList[j].readType = relatedReadType
                if (relatedReadType !== 0) {
                  this.getRelatedReadTitleListByReadType(true, i, j)
                }
              }
            }
          }
        } else {
          this.taskList = []
          this.total = 0
        }
      })
    },
    getTaskActivityStyleList () {
      // 编辑任务活动 获取活动形式列表
      const param = { access_token: this.access_token }
      this.$http.post(requestUrl.getTaskActivityStyleList, param).then(res => {
        console.log(res)
        if (res) {
          this.activityListType = res || []
        }
      })
    },
    getRelatedReadTitleListByReadType (b, i, j) {
      let relatedReadType = 1
      if (b) {
        relatedReadType = this.taskList[i].activityList[j].relatedReadType
      } else {
        relatedReadType = this.readType
      }
      const param = {
        styleId: this.styleId,
        readType: relatedReadType || 1,
        access_token: this.access_token
      }
      const _this = this
      _this.$http.post(requestUrl.getRelatedReadTitleListByReadType, param).then(res => {
        _this.bookList = res
        // console.log('relatedReadType',relatedReadType)
        // console.log('relatedReadType2',i.relatedReadType)
        // console.log('bookList',_this.bookList)
        // console.log('bookList2',_this.bookList2)
        // console.log('bookLis3t',_this.bookList3)
        // if (b) {
        //   const relatedReadId = this.taskList[i].activityList[j].relatedReadId
        //   for (let k = 0; k < _this.bookList.length; k++) {
        //     if (relatedReadId === _this.bookList[k].id) {
        //       this.taskList[i].activityList[j].relatedReadContent = _this.bookList[k].title
        //     }
        //   }
        // }
      })
    },
    publish (item) {
      if (item.isPublish === 0) {
        this.publishMess = item
        this.publishVis = true
      }
    },
    changeType (item, index) {
      this.publishTypeNum = item.type
      this.currentTypeIndex = index
      this.allSelectedNodes = []
      this.checkClassIds = []
      this.allClassIds = []
    },
    checkClass (e) {
      this.allClassIds = e
    },
    pubCancel () {
      this.publishVis = false
      this.allClassIds = this.$store.getters.allClassIds
      this.timeDate = ''
    },
    timeChange (value, dateString) {
      this.timeDate = dateString
    },
    timeOk (val) {
      this.timeDate = val
      console.log(val)
      console.log(this.timeDate)
    },
    pubSure () {
      const groupId = format.del_array_diff(this.allSelectedNodes, this.checkClassIds)
      console.log(format.formatTime(this.timeDate))
      console.log(groupId)
      console.log(this.allClassIds)
      if (this.timeDate === '') {
        this.$message.warning('缺少时间')
        return
      }
      if (this.publishTypeNum === 2 && groupId.length === 0) {
        this.$message.warning('缺少群组')
        return
      }
      if (this.publishTypeNum === 1 && this.allClassIds.length === 0) {
        this.$message.warning('缺少班级')
        return
      }
      const param = {
        id: this.publishMess.id, // 发布任务id
        classIds: this.allClassIds, // 要发布班级id列表 发布类型为1 时传入
        pushEndDate: format.formatTime(this.timeDate), // 任务截止日期
        groupIds: groupId, // 群组id集合，要发布的班级小组列表 发布类型为2 时传入
        styleId: this.styleId, // 体例id
        pushTaskType: this.publishTypeNum,
        access_token: this.access_token,
        teacherId: this.teacherId
      }
      this.$http.post(requestUrl.publishTask, param).then(res => {
        if (res) {
          this.$message.success('发布成功')
          this.getList()
          this.publishVis = false
        }
      })
    },
    // getInput (val) {
    //   this.addActivityParam.content = val
    // },
    disabledDate (current) {
      return current && current < moment().subtract(1, 'days')
    },
    getClassData () {
      // 获取班级，发布的时候使用
      this.$fetch({
        url: this.$baseUrl + 'ebook/class/v3/common/getSimpleClaList',
        body: { userId: this.$getUserInfo().id }
      }).done(res => {
        if (res && res.success && res.resultCode === '0') {
          this.classData = res.resultData
          // this.classId = this.classData[0].id || ''
          if (Array.isArray(this.classData) &&
              this.classData.length > 0 &&
              this.classData[0] &&
              this.classData[0].id !== undefined) {
            this.classId = this.classData[0].id
          }
          // this.getV2Group()
          for (let i = 0; i < res.resultData.length; i++) {
            const element = res.resultData[i]
            this.treeData.push(element)
          }
        }
      })
    },
    getV2Group (treeNode) {
      // 根据班级id 获取小组--重新拆分接口，减少原大接口耗时
      console.log(treeNode)
      console.log(treeNode.eventKey)
      const _this = this
      return new Promise(resolve => {
        if (treeNode.dataRef.children) {
          resolve()
          return
        }
        _this.$fetch({
          url: _this.$baseUrl + 'ebook/class/v3/common/getSimpleClassGroupList',
          body: { classId: treeNode.eventKey }
        })
          .done((res) => {
            if (res && res.success && res.resultCode === '0') {
              const resultData = res.resultData
              const dataList = []
              // 判断chidlren是否为空，并修改isLeaf属性值
              if (resultData.length === 0) {
                treeNode.disabled = false
              }
              for (let i = 0; i < resultData.length; i++) {
                const element = resultData[i]
                const data = {
                  key: element.id,
                  title: element.groupName,
                  isLeaf: true
                }
                dataList.push(data)
              }
              treeNode.children = dataList
              treeNode.dataRef.children = dataList
              this.treeData = [...this.treeData]
              resolve()
            }
          })
      })
    },
    editUpLoadLib (item) {
      // 添加学习任务-资源库展示
      const param = {
        teacherId: this.$getUserInfo().id,
        type: 1,
        styleId: localStorage.getItem('styleId')
      }
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/base/getTeacherResourceBase',
        body: param
      })
        .loading(
          () => (this.loading = true),
          () => (this.loading = false)
        )
        .done((res) => {
          this.dataList = res.resultData
          this.plainOptions = res.resultData
          this.loading = false
        })
      this.savecheckImg = []
      this.savecheckVideo = []
      this.savecheckAudio = []
      this.libraryVis = true
      this.currentActivityList = item
      this.editActivityList = item
    },
    libraryCancel () {
      // 资源库选择关闭
      this.libraryVis = false
    },
    addDelImg (e, i) {
      // 添加学习任务，删除图片
      this.addActivityParam.activityList[i].imageList.splice(e, 1)
    },
    addDelVideo (e, i) {
      // 添加学习任务，删除视频
      // const index = this.currentActivityList.videoList.findIndex((item) => item.id === e.id)
      this.addActivityParam.activityList[i].videoList.splice(e, 1)
    },
    addDelAudio (e, i) {
      // 添加学习任务，删除语音
      this.addActivityParam.activityList[i].audioList.splice(e, 1)
    },
    playSound (au) {
      // 添加学习任务，播放语音
      console.log(au)
      this.preAudioVisible = true
      this.previewFile = { name: '音频', url: this.resBaseVideo + '/' + au.path }
    },
    editDelImg (index, i) {
      // 编辑学习任务，删除图片
      this.editTaskMess.activityList[i].imageList.splice(index, 1)
    },
    editdelVideo (index, i) {
      // 编辑学习任务，删除视频
      this.editTaskMess.activityList[i].videoList.splice(index, 1)
    },
    editDelAudio (index, i) {
      // 编辑学习任务，删除音频
      this.editTaskMess.activityList[i].audioList.splice(index, 1)
    },
    sureImg () {
      // 资源库选择内容--确定
      const number = this.savecheckImg.length + this.savecheckVideo.length + this.savecheckAudio.length
      if (number > 9) {
        this.$message.error('最多选择9项内容')
        return
      }
      if (this.addType === '1') {
        // 新增弹窗
        this.currentActivityList.imageList = this.imgTrans
        this.currentActivityList.videoList = this.videoTrans
        this.currentActivityList.audioList = this.audioTrans
        // 将选择好的图片组合为一个数组，方便一行显示
      }
      if (this.addType === '2') {
        // 编辑弹窗
        // this.editimgTrans = [...this.editimgTrans, ...this.imgTrans]
        // this.editvideoTrans = [...this.editvideoTrans, ...this.videoTrans]
        // this.editaudioTrans = [...this.editaudioTrans, ...this.audioTrans]
        this.editActivityList.imageList = this.imgTrans
        this.editActivityList.videoList = this.videoTrans
        this.editActivityList.audioList = this.audioTrans
      }
      console.log(this.savecheckVideo)
      console.log(this.currentActivityList)
      console.log(this.editActivityList)

      this.imgTrans = []
      this.videoTrans = []
      this.audioTrans = []
      this.libraryVis = false
    },
    onSearch () {
      if (this.searchName === '') {
        this.$message.error('请输入查询内容')
      } else {
        this.getResourceList()
      }
    },
    tabList (key) {
      switch (key) {
        case '1':
          this.type = 1
          this.loading = true
          this.getResourceList()
          break
        case '2':
          this.type = 2
          this.loading = true
          this.getResourceList()
          break
        case '5':
          this.type = 5
          this.loading = true
          this.getResourceList()
          break
        default:
          this.type = 1
      }
    },
    checkedImg (e) {
      this.savecheckImg = e
      // 转格式
      const newImgList1 = []
      const newImgList = []
      for (let i = 0; i < this.dataList.length; i++) {
        const element = this.dataList[i]
        for (let j = 0; j < this.savecheckImg.length; j++) {
          const ele = this.savecheckImg[j]
          if (element.filePath === ele) {
            newImgList1.push(element)
          }
        }
      }
      newImgList1.forEach((item) => {
        newImgList.push({
          path: item.filePath,
          coverPath: '',
          id: '',
          thumbnaiPath: '',
          timeLength: '',
          name: (item.fileName && item.fileName.replace(/(.*\/)*([^.]+).*/gi, '$2')) || '图片.png'
        })
      })
      this.imgTrans = newImgList
    },
    checkedVideoListFun (e) {
      this.savecheckVideo = e
      // 转格式
      const newVideoList1 = []
      const newVideoList = []
      for (let i = 0; i < this.dataList.length; i++) {
        const element = this.dataList[i]
        for (let j = 0; j < this.savecheckVideo.length; j++) {
          const ele = this.savecheckVideo[j]
          if (element.filePath === ele) {
            newVideoList1.push(element)
          }
        }
      }
      newVideoList1.forEach((item) => {
        newVideoList.push({
          path: item.filePath,
          coverPath: '',
          id: '',
          thumbnaiPath: '',
          timeLength: '',
          name: (item.fileName && item.fileName.replace(/(.*\/)*([^.]+).*/gi, '$2')) || '视频.mp4'
        })
      })
      this.videoTrans = newVideoList // 把转换为新的数组复制给变量数组
    },
    checkedAudioListFun (e) {
      this.savecheckAudio = e
      // 转格式
      const newAudioList1 = []
      const newAudioList = []
      for (let i = 0; i < this.dataList.length; i++) {
        const element = this.dataList[i]
        for (let j = 0; j < this.savecheckAudio.length; j++) {
          const ele = this.savecheckAudio[j]
          if (element.filePath === ele) {
            newAudioList1.push(element)
          }
        }
      }
      newAudioList1.forEach((item) => {
        newAudioList.push({
          path: item.filePath,
          coverPath: '',
          id: '',
          thumbnaiPath: '',
          timeLength: '',
          name: (item.fileName && item.fileName.replace(/(.*\/)*([^.]+).*/gi, '$2')) || '音频.mp3'
        })
      })
      this.audioTrans = newAudioList // 把转换为新的数组复制给变量数组
    },
    getResourceList () {
      // 获取资源列表
      const param = {
        teacherId: this.$getUserInfo().id,
        type: this.type,
        styleId: localStorage.getItem('styleId'),
        fileName: this.searchName
      }
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/base/getTeacherResourceBase',
        body: param
      })
        .loading(
          () => (this.loading = true),
          () => (this.loading = false)
        )
        .done((res) => {
          this.dataList = res.resultData
          this.plainOptions = res.resultData
          // this.newImgList = res.resultData
          this.loading = false
        })
    },
    uploadPhotoLi () {
      // 上传资源弹窗
      this.uploadShowVis = true
      this.photoName = ''
    },
    beforeUpload1 (file) {
      // 点击上传资源
      // console.log(1111, file);
      // console.log(this.type);
      if (file == null) {
        this.$message.warning('请选择文件')
        return
      }
      if (this.type === 1 && file.type !== 'image/png' && file.type !== 'image/jpeg') {
        this.$message.warning('请您上传正确的格式，支持PNG、JPG格式')
        return
      } else if (this.type === 2 && file.type !== 'video/mp4') {
        this.$message.warning('请您上传正确的格式，支持mp4格式')
        return
      } else if (this.type === 5 && file.type !== 'audio/mpeg') {
        this.$message.warning('请您上传正确的格式，支持mp3格式')
        return
      }
      const formData = new FormData()
      formData.append('file', file)
      formData.append('customDir', 'hytc_ebook_server/file')
      formData.append('access_token', this.access_token || '')
      this.photoName = file.name
      // 上传图片方法;
      const _this = this
      axios({
        url: _this.$uploadUrl,
        method: 'post',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then((res) => {
        if (res && res.status === 200) {
          _this.uploadCommon(_this.type, res.data.url, _this.photoName)
          setTimeout(() => {
            _this.getResourceList()
          }, 1000)
        }
      })
    },
    uploadCommon (type, url, fileName) {
      const param = {
        teacherId: this.$getUserInfo().id,
        type: type,
        filePath: url,
        fileName: fileName
      }
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/base/saveBaseResource',
        body: param
      })
        .loading(
          () => (this.loading = true),
          () => (this.loading = false)
        )
        .done((res) => {
          this.$message.success('上传成功')
          this.loading = false
          this.uploadShowVis = false
        })
    },
    uploadShowCancel () {
      this.uploadShowVis = false
    },
    handleCancel () {
      this.previewVisible = false
    },
    async handlePreview (file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    },
    handleChange (info) {
      if (info.file.status === 'uploading') {
        this.loading = true
        return
      }
      if (info.file.status === 'done') {
        // Get this url from response in real world.
        this.getBase64(info.file.originFileObj, (imageUrl) => {
          this.imageUrl = imageUrl
          this.loading = false
        })
      }
    },
    getBase64 (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = (error) => reject(error)
      })
    }
  },
  components: {
    // DownOutlined,
    FilePreview,
    RichTextView,
    TinyEditor,
    mySelect
  }
}
</script>

<style lang="less" scoped>
p {
  line-height: 1.8em !important;
  margin: 0em !important;
}

ul, li {
  margin: 0;
  padding: 0;
  list-style: none;
}

.mt20 {
  margin-top: 20px !important;
}

.main {
  // width: 1240px;
  height: calc(100vh - 185px);
  //max-height: 600px;
  overflow-y: auto;
  min-height: 500px;
  background: #fff;
  margin: 20px 20px;
  padding: 15px 30px 50px 30px;
  border-radius: 10px;

  .title {
    display: flex;
    height: 35px;
    line-height: 35px;

    .t-l {
      color: #333;
      font-size: 16px;
      font-weight: 600;
    }

    .t-r {
      margin-left: auto;
      font-size: 14px;
      color: #d7d7d7;
      display: flex;

      .use-his {
        color: @primary-color;
        cursor: pointer;
        // margin-right: 15px;
      }

      .pre {
        color: @primary-color;
        cursor: pointer;
      }

      .add-pre {
        display: inline-block;
        width: 80px;
        height: 24px;
        margin-top: 5px;
        line-height: 24px;
        background: @primary-color;
        border-radius: 2px;
        color: #fff;
        text-align: center;
        margin-left: 20px;
        cursor: pointer;

        .add-img {
          width: 16px;
          height: 16px;
        }

        .add-text {
          margin-left: 5px;
        }
      }
    }
  }

  .cont-ul {
    .cont-li {
      background: #F1F0F0;
      margin-top: 15px;
      border-radius: 6px;

      .task-title {
        font-size: 16px;
        color: #333;
        font-weight: 600;
        padding: 20px 0px 20px 30px;
        display: flex;

        .task-content {
          flex: 1;
          margin-right: 10px;
        }

        .task-type {
          width: 100px;

          .type-detail {
            display: inline-block;
            // height: 30px;
            // line-height: 30px;
            border-radius: 15px;
            text-align: center;
            color: #867D7B;
            font-weight: 400;
            font-size: 14px;

            .img-type-detail {
              height: 24px;
              width: 24px;
              margin-top: -2px;
            }
          }
        }
      }

      .activity-ul {
        margin: 0 30px;

        .activity-li {
          display: flex;
          border-radius: 4px;
          margin-bottom: 5px;

          .act-num {
            color: #867D7B;
            font-size: 14px;
            width: 50px;
          }

          .act-type {
            color: @primary-color;
            font-size: 14px;
            margin-left: 5px;
            // width: 70px;
          }

          .act-cont {
            color: #666;
            font-size: 14px;
            margin-left: 10px;
            flex: 1;
          }
        }

        .act-li {
          // display: flex;
          // justify-content: flex-start;

          .act-read {
            color: #1e90ff;
            font-size: 14px;
            margin-left: 10px;

          }
        }

        .content {
          margin-bottom: 10px;
        }
      }

      .task-status {
        border-top: 1px solid #D7D7D7;
        display: flex;
        margin: 0 30px;
        padding: 20px 0;

        .status-l {
          font-size: 14px;

          .zt {

          }

          .sy {
            color: @primary-color;
          }
        }

        .status-r {
          margin-left: auto;

          span {
            color: @primary-color;
            padding: 0 5px;
            cursor: pointer;
            display: inline-block;
            width: 80px;
            height: 24px;
            line-height: 24px;
            text-align: center;
            border-radius: 2px;
            border: 1px solid @primary-color;
            margin-left: 8px;
          }

          .feedBack-no {
            color: #BDBDBD;
            padding: 0 5px;
            display: inline-block;
            width: 80px;
            height: 24px;
            line-height: 24px;
            text-align: center;
            border-radius: 2px;
            border: 1px solid #BDBDBD;
            margin-left: 8px;
            cursor: not-allowed
          }

          .publish-btn {
            background: @primary-color;
            color: #fff;
          }

          .no-e {
            width: 80px;
            text-align: center;
            line-height: 24px;
            background: #F1F0F0;
            border-radius: 2px;
            border: 1px solid #bdbdbd;
            color: #bdbdbd;

            margin-left: 10px;
            cursor: not-allowed;
          }

          .has-e {
            width: 80px;
            text-align: center;
            line-height: 24px;
            background: #F1F0F0;
            border-radius: 2px;
            border: 1px solid @primary-color;
            color: @primary-color;
            margin-right: 10px;
            margin-left: 10px;
            cursor: pointer;
          }

          .has-ep {
            width: 80px;
            text-align: center;
            line-height: 24px;
            background: @primary-color;
            border-radius: 2px;
            border: 1px solid @primary-color;
            color: #fff;
            cursor: pointer;
          }
        }
      }

    }
  }

}

//addTask-start
.task-top {
  height: 30px;
  line-height: 30px;

  .xing {
    color: @red-color;
    font-size: 14px;
  }
}

.task-in {
  margin-top: 20px;
  border-bottom: 1px solid #fff;

  .text-area {
    height: 90px;
    width: 100%;
    background: #f2f2f2;
    cursor: pointer;
  }
}

.add-activity {
  margin-top: 20px;

  .activi-li {
    margin-top: 15px;

    .activity-name {
      display: flex;

      .act-name {
        color: #333;
        font-size: 16px;
        font-weight: 600;
      }

      .del {
        color: @red-color;
        margin-left: auto;
        cursor: pointer;
      }

      .task_add {
        width: 30px;
        height: 30px;
        margin-right: 15px;
        margin-left: auto;
        cursor: pointer;
      }

      .task_delete {
        width: 25px;
        height: 25px;
        margin-top: 2px;
      }
    }

    .activity-type {
      display: flex;
      margin-bottom: 20px;

      .read-left {
        height: 30px;
        line-height: 30px;
        margin-top: 8px;

        .xing {
          color: @red-color;
          font-size: 14px;
        }
      }

      .read-right {
        margin-left: auto;
        display: flex;
        // height: 30px;
        line-height: 30px;
        margin-top: 8px;

        .xing {
          color: @red-color;
          font-size: 14px;
        }
      }

    }

    .read-type {
      display: flex;
      margin-bottom: 20px;

      .read-left {
        line-height: 30px;
        margin-top: 8px;

        .xing {
          color: @red-color;
          font-size: 14px;
        }
      }

      .read-right {
        margin-left: auto;
        display: flex;
        line-height: 30px;
        margin-top: 8px;

        .xing {
          color: @red-color;
          font-size: 14px;
        }
      }

    }

    // 添加学习内容--资源上传
    .imgList {
      width: 100%;
      margin-top: 10px;
      display: flex;

      .prev-box {
        width: 100px;
        height: 80px;
        cursor: zoom-in;
        margin: 5px;
        border: solid 1px #ccc;
        object-fit: cover;
        border-radius: 8px;
      }

      // 添加学习内容--图片
      .newImg {
        width: 100px;
        height: 80px;
        margin-top: 10px;
        margin-right: 10px;
        position: relative;

        .del {
          display: none;
          width: 20px;
          height: 20px;
          z-index: 99;
          position: absolute;
          right: 2px;
          top: 2px;
        }

        &:hover {
          .del {
            display: block;
            cursor: pointer;
          }
        }
      }

      // 添加学习内容--视频
      .editVideo {
        position: relative;
        width: 100px;
        height: 80px;
        margin-top: 10px;
        margin-right: 10px;
        background-color: black;
        display: inline-block;
        text-align: center;

        .editvideoPlay {
          width: 100px;
          height: 80px;
        }

        .del {
          display: none;
          width: 20px;
          height: 20px;
          z-index: 99;
          position: absolute;
          right: 6px;
          top: 6px;
        }

        &:hover {
          .del {
            display: block;
            cursor: pointer;
          }
        }
      }

      // 添加学习内容--音频
      .editAudio {
        position: relative;
        width: 100px;
        height: 80px;
        margin-right: 10px;
        margin-bottom: 20px;
        display: inline-block;
        text-align: center;

        .editvideoPlay {
          width: 100px;
          height: 80px;
        }

        .del {
          display: none;
          width: 20px;
          height: 20px;
          z-index: 99;
          position: absolute;
          right: 6px;
          top: 6px;
        }

        &:hover {
          .del {
            display: block;
            cursor: pointer;
          }
        }
      }
    }

    // 添加学习内容--资源添加
    .task_add_img {
      width: 80px;
      height: 80px;
      margin-top: 10px;
    }

    .activity-input {
      margin-top: 18px;
    }

    .text-area {
      height: 90px;
      width: 100%;
      background: #f2f2f2;
      cursor: pointer;
      margin-top: 15px;
    }
  }

  .add-act {
    color: @primary-color;
    height: 50px;
    line-height: 50px;
    cursor: pointer;
    width: 100px;
  }
}

//addTask-end
.currentType {
  display: inline-block;
  text-align: center;
  width: 60px;
  height: 24px;
  line-height: 24px;
  background: #F1F0F0;
  // border: 1px solid #ddd;
  color: #867D7B;
  margin-right: 10px;
  border-radius: 2px;
  cursor: pointer;
}

.currentTypeAct {
  display: inline-block;
  text-align: center;
  width: 60px;
  height: 24px;
  line-height: 24px;
  background: @primary-color;
  color: #fff;
  margin-right: 10px;
  border-radius: 2px;
  cursor: pointer;
}

.publish-task {
  width: 300px;
  margin: 0 auto;
  color: #000;
  font-size: 16px;

  .publish-time {
    display: flex;

    .remend {
      width: 18px;
      height: 18px;
      margin: 6px 0px 0px 10px;
    }

    .r {
      display: flex;
    }
  }

  .publish-top {
    margin-top: 15px;
    height: 30px;

    .l {
      text-indent: 15px;
    }

    .r {
      height: 30px;
    }
  }

  .publish-bot {
    .l {
      margin-top: 12px;
    }

    .classSelect {
      margin-top: 12px;
      font-size: 14px;
      color: #797979;
    }
  }
}

.warning {
  color: #DB5647;
  font-size: 16px;
  height: 30px;
  line-height: 30px;
  text-align: center;
}

.sure-text {
  color: #040506;
  font-size: 16px;
  height: 30px;
  line-height: 30px;
  text-align: center;
}

// 删除学习任务对话框
.del-m {
  width: 250px;
  margin: auto;
  text-align: center;

  .del-t {
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #DB5647;
    line-height: 24px;
  }

  .del-s {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #040506;
    line-height: 24px;
  }
}

.f-del {
  display: flex;
  width: 180px;
  margin: 0 auto;

  div {
    width: 80px;
    height: 24px;
    line-height: 24px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    border-radius: 2px;
    text-align: center;
    margin: auto;
    cursor: pointer;
  }

  .f-c {
    background: #FFFFFF;
    border: 1px solid #DBD1CD;
    color: #867D7B;
  }

  .f-s {
    background: @primary-color;
    color: #fff;
    margin-left: 20px;
  }
}

/deep/ .ant-calendar-footer-btn a {
  color: @primary-color !important;
}

/deep/ .ant-divider, .ant-divider-vertical {
  margin: 10px 8px;
}

/deep/ .ant-checkbox + span {
  color: #1D2129;
  font-size: 16px;
  font-family: PingFangSC-Regular;
  padding-left: 10px;
}

/deep/ table {
  border: 1px solid #ccc !important;
}

/deep/ th {
  border: 1px solid #ccc !important;
  min-height: 30px;
  height: 30px;
  text-align: center;
  background: #f3f1f2;
}

/deep/ td {
  border: 1px solid #ccc !important;
  min-height: 30px;
  height: 30px;
  text-align: center;
}

/deep/ video {
  width: 200px;
  height: 100px;
}

.mainLib {
  background-color: @white;
  border-radius: @border-radius-base;
  //   width: 1240px;
  margin: 0 auto;
  margin-bottom: 30px;
  position: relative;

  .load {
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(50%, 50%);
    z-index: 99;
  }

  .sureNum {
    width: 140px;
    height: 44px;
    text-align: center;
    line-height: 44px;
    color: #9d9292;
    font-size: 16px;
    position: absolute;
    right: 130px;
    top: 30px;
  }

  .sureImg {
    cursor: pointer;
    z-index: 99;
    width: 140px;
    height: 44px;
    text-align: center;
    line-height: 44px;
    background-color: @primary-color;
    border-radius: 8px;
    color: #fff;
    font-size: 16px;
    position: absolute;
    right: 0px;
    top: 30px;
  }

  .upLoad {
    display: flex;
    position: absolute;
    right: 10px;
    top: 30px;
    z-index: 9;

    .textLeft {
      width: 100px;
      height: 30px;
      line-height: 30px;
      margin-top: 20px;
      color: #040506;
      font-size: 20px;
      letter-spacing: 5px;
    }

    .imgSize {
      width: 80px;
      height: 80px;
      border-radius: 50%;
    }
  }

  .imgTop {
    width: 275px;
    height: 157px;

    .video {
      width: 100%;
      height: 157px;
    }

    img {
      width: 100%;
      height: 157px;
    }
  }

  .imgBot {
    display: flex;
    margin-top: 10px;
    width: 275px;

    .imgName {
      flex: 22;
      color: #9d9292;
      font-size: 16px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;

      .usePhoto {
        height: 22px;
        line-height: 22px;
      }
    }

    .imgDel {
      color: #db5647;
      flex: 2;
      text-align: right;
      font-size: 16px;
      cursor: pointer;
    }
  }

  .search {
    width: 60%;
    height: 50px;
  }

  .tabList {
    min-height: 400px;

    .upload {
      display: inline-block;
      width: 50%;
      color: #a3af90;

      &:hover {
        cursor: pointer;
      }
    }

    .del {
      display: inline-block;
      width: 50%;
      color: #db5647;

      &:hover {
        cursor: pointer;
      }
    }

    ul {
      li {
        float: left;
        width: 275px;
        margin-right: 20px;
      }

      li:nth-child(3n) {
        margin-right: 0px;
      }

      /deep/ .ant-checkbox-group {
        width: 902px;
      }
    }

    .uploadLi {
      background-image: url('../../../../assets/image/upload.png');
      background-size: cover;
      width: 275px;
      height: 157px;
      margin-right: 20px;
      cursor: pointer;
    }
  }

  .dalog,
  .editdalog {
    .mess {
      width: 1000px;
      height: 150px;
      border: 1px solid #e1d9c2;
      background-color: #f8f8f8;
      padding: 20px 30px 0px 30px;

      p {
        color: #000;
        letter-spacing: 0px;
        font-size: 16px;
        line-height: 32px;
      }
    }

    .imgList {
      margin-top: 20px;
      min-height: 150px;
    }

    .uploadImg {
      margin-top: 20px;
      display: flex;

      .uploadLib {
        cursor: pointer;
        width: 120px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        background-color: #a3af90;
        border-radius: 4px;
        color: #fff;
      }

      .addMap {
        cursor: pointer;
        width: 120px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        background-color: @primary-color;
        border-radius: 4px;
        color: #fff;
        margin-left: 20px;
      }
    }
  }
}

.relatedReadInfo-content {
  padding: 20px 40px;
  font-size: 18px;
  position: relative;

  .prev {
    font-size: 16px;
    color: @primary-color;
    position: absolute;
    cursor: pointer;
    right: 100px;
    top: 5px;
  }

  .next {
    font-size: 16px;
    color: @primary-color;
    position: absolute;
    cursor: pointer;
    right: 40px;
    top: 5px;
  }

  .relatedReadInfo-title {
    margin-right: 20px;
    font-size: 24px;
    text-align: center;
  }

  .relatedReadInfo-author {
    text-align: center;
    font-size: 16px;
    color: #cccccc;
  }
}

/deep/ .ant-modal-body {
  max-height: calc(80vh - 50px);
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 6px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }

  &::-webkit-scrollbar-thumb {
    // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #e3e3e6;
    border-radius: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 5px;
  }
}
</style>
